// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"6e5a996b","239":"09f41d88","732":"c128d2d4"}[chunkId] + ".chunk.js";
};